<div class="flex flex-col items-center justify-center" [class]="customClass">
  <div class="flex flex-col gap-54" [class]="customClass + '-container'">

    <pin-logo [type]="logoType.LOGIN" customClass="login-logo" class="hidden lg:block"></pin-logo>

    <div class="flex flex-col gap-10 ">
      <div class="flex flex-col gap-2">
        <h1 class="dcp-h1 white-color">First time here?</h1>
        <p class="dcp-body white-color">
          Click “Register” to get started.
        </p>
      </div>

      <pin-button
        [buttonId]="'registration-button' + (customClass === 'registration-side-desktop' ? '-desktop' : '-mobile')"
        customClass="white-button w-full"
        buttonStyle="filled" redirectUrl="/register">REGISTER
      </pin-button>
    </div>
  </div>
</div>
